import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'input[appFormInput], textarea[appFormInput], select[appFormInput]'
})
export class FormInputDirective {
  @HostBinding('class') inputClasses = 'sv-input';
}
